/**
 * The links someone put on their profile.
 *
 * One shape for all of them: a mono label saying where it goes, a title, and a
 * line of what is there. An account fills that with its handle and the bio
 * from the service; a page fills it with its own title and description.
 *
 * They were briefly two shapes, because an account had no second line to put
 * anything on and rendered a blank one. It has a bio now, so the split has
 * nothing left to justify it.
 *
 * Every string except the label was written by a stranger's server. The host
 * is drawn from the URL rather than the document, so a title can never claim
 * to be somewhere it is not.
 */
export default function ProfileLinks({ links }) {
  if (!links?.length) return null;

  return (
    <div className="profile-links">
      {links.map((link) => {
        const account = link.kind === 'account';
        const pending = link.state === 'pending';
        const read = link.state === 'ok' && link.title;

        const label = account ? link.service : (link.site || link.host);
        const title = account ? link.handle : read ? link.title : link.host;
        const line = link.summary ? link.summary
          : pending ? 'Reading that link…'
          : link.url.replace(/^https:\/\//, '');

        return (
          <a
            key={link.id}
            className={`profile-link ${pending ? 'pending' : ''}`}
            href={link.url}
            target="_blank"
            // A profile is a page strangers link to. noopener is the part that
            // matters; noreferrer keeps this site out of their logs.
            rel="noopener noreferrer nofollow"
          >
            <span className="link-site">{label}</span>
            <span className="link-body">
              <span className="link-title">{title}</span>
              {/* Held even when there is nothing to say, so a row keeps its
                  height when the fetch lands and does not push the feed down
                  under a cursor. */}
              <span className="link-sum">{line}</span>
            </span>
          </a>
        );
      })}
    </div>
  );
}
